import React, { useMemo } from "react";
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  ZAxis,
} from "recharts";
import "../css/DashboardTopServices.css";

// 🔒 Static bubble positions & sizes
const STATIC_LAYOUT = [
  { x: 220, y: 140, z: 2000, label: "Grooming", color: "#0066FF" },
  { x: 340, y: 100, z: 1500, label: "Doctor Appointments", color: "#00C2FF" },
  { x: 200, y: 60,  z: 1000, label: "Walking", color: "#00C97E" },
];

const TopServiceCard = ({ data = [] }) => {
  // Convert API data into a lookup map {serviceName: count}
  const counts = useMemo(() => {
    const map = {
      Grooming: 0,
      "Doctor Appointments": 0,
      Walking: 0,
    };

    data.forEach((item) => {
      if (item.service === "Grooming") map["Grooming"] = item.daily_count;
      if (item.service === "Walking") map["Walking"] = item.daily_count;
      if (
        item.service === "Doctor Appointments" ||
        item.service === "Doctor Appointment"
      ) {
        map["Doctor Appointments"] = item.daily_count;
      }
    });

    return map;
  }, [data]);

  // Merge static positions with dynamic counts
  const services = STATIC_LAYOUT.map((item) => ({
    ...item,
    count: counts[item.label] ?? 0,
  }));

  return (
    <div className="top-service-card">
      <h3 className="top-service-title">Top Service</h3>

      <div className="bubble-wrapper" style={{ border: "none" }}>
        <ScatterChart width={500} height={400} style={{ pointerEvents: "none" }}>
          <XAxis dataKey="x" type="number" domain={[0, 500]} hide />
          <YAxis dataKey="y" type="number" domain={[0, 200]} hide />
          <ZAxis dataKey="z" range={[80, 160]} />
          <Scatter
            data={services}
            shape={({ cx, cy, size, payload }) => (
              <g>
                <circle cx={cx} cy={cy} r={size / 1.5} fill={payload.color} />
                <text
                  x={cx}
                  y={cy - 10}
                  textAnchor="middle"
                  fill="#fff"
                  fontSize={16}
                >
                  {payload.label}
                </text>
                <text
                  x={cx}
                  y={cy + 5}
                  textAnchor="middle"
                  fill="#fff"
                  fontWeight="bold"
                  fontSize={16}
                >
                  {payload.count >= 1000 ? `${payload.count / 1000}k` : payload.count}
                </text>
                <text
                  x={cx}
                  y={cy + 20}
                  textAnchor="middle"
                  fill="#fff"
                  fontSize={14}
                >
                  Per Day
                </text>
              </g>
            )}
          />
        </ScatterChart>
      </div>

      <div className="service-list">
        {services.map((service, index) => (
          <div className="service-item" key={index}>
            <span className="service-rank">
              {index + 1}. {service.label}
            </span>
            <span className="service-count">{service.count}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopServiceCard;
